import React from "react";

function Education() {
  return (
    <div className="container mt-5">
      <div className="row gy-4 align-items-center">
        <div className="col-12 col-lg-6 text-center text-lg-start">
          <img src="media/images/education.svg" alt="Education" className="img-fluid" style={{ maxWidth: "70%" }} />
        </div>
        <div className="col-12 col-lg-6">
          <h1 className="mb-3 fs-2">Free and open market education</h1>
          <p>
            Varsity, the largest online stock market education book in the world
            covering everything from the basics to advanced trading.
          </p>
          <a href="" style={{ textDecoration: "none" }}>
            Varsity <i className="fa-solid fa-arrow-right"></i>
          </a>

          <p className="mt-4 mt-lg-5">
            TradingQ&A, the most active trading and investment community in
            India for all your market related queries.
          </p>
          <a href="" style={{ textDecoration: "none" }}>
            TradingQ&A <i className="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Education;
